const styles = {
    boxWidth: "m:max-w-[1000px] s:max-w-[720px] xs:max-w-[480px] w-full",
    
    H1: "font-inter font-medium m:text-[48px] s:text-[40px] text-[32px] m:leading-[56px] s:leading-[48px] leading-[40px] tracking-[1px]", 
    H2: "font-inter font-semibold m:text-[32px] s:text-[28px] text-[24px] m:leading-[40px] s:leading-[36px] leading-[32px]", 
    H3: "font-inter font-medium m:text-[24px] s:text-[20px] text-[16px] m:leading-[32px] s:leading-[28px] leading-[24px]",
    Body: "font-inter font-normal text-[12px] leading-[16px]",
    Paragraph: "font-inter font-normal text-[12px] leading-[20px]", 
  
    flexCenter: "flex justify-center items-center",
    flexStart: "flex justify-center items-start",
  
    paddingX: "px-[1.5rem] xs:px-[3rem] m:px-[4rem]",
    paddingY: "py-[3rem] xs:py-[4rem] m:py-[7rem]",

    colCenter: "flex flex-col items-center",
    };

  export default styles;